import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

type UseKnowledgeCrawlsQueryOptions = {
  databaseId: string | undefined;
  enabled: boolean;
};

export function useKnowledgeCrawlsQuery({
  databaseId,
  enabled,
}: UseKnowledgeCrawlsQueryOptions) {
  const { user } = useAuth();
  const isEnabled = enabled && Boolean(user) && Boolean(databaseId);

  return useQuery({
    queryKey: knowledgeQueryKeys.crawls(databaseId ?? ''),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listCrawls(databaseId!),
  });
}
